export const getTitlePageFromRoute = [
  {
    route: '/statistic',
    exception: true,
    myStatistic: true,
  },
  {
    route: '/ranking',
    title: 'ranking',
    withoutTree: true,
    withoutHeader: true,
  },
  {
    route: '/domains',
    title: 'domains',
    withArrow: true,
    withoutHeaderDesktop: true,
  },
  {
    route: '/pragmatic-tournament',
    title: 'pragmaticTournament',
    withoutTree: true,
    withoutHeader: true,
  },
  {
    route: '/jacktop-tournament',
    title: 'jacktopTournamentTitle',
    withoutTree: true,
    withoutHeader: true,
  },
  // {
  //   route: '/ruby-play-tournament',
  //   title: 'rubyPlayTournamentTitle',
  //   withoutTree: true,
  //   withoutHeader: true,
  // },
  // {
  //   route: '/netent-tournament',
  //   title: 'netentTournamentTitle',
  //   withoutTree: true,
  //   withoutHeader: true,
  // },
  {
    route: '/users/',
    title: 'users',
  },
  {
    route: '/reports/financial-reports/general',
    title: 'generalReport',
    withArrow: true,
  },
  {
    route: '/creative-functionality/custom',
    title: 'custom',
    withArrow: true,
  },
  {
    route: '/creative-functionality/custom-requests',
    title: 'customRequests',
    withArrow: true,
  },
  {
    route: '/reports/financial-reports/cash',
    title: 'depositsAndWithdrawals',
    withArrow: true,
  },
  {
    route: '/reports/player-reports/player-history',
    title: 'playerHistory',
    withArrow: true,
  },
  {
    route: '/reports/player-reports/detail-by-player',
    title: 'playerAndAgentDetail',
    dynamicTitle: authData => (authData.canCreateOnlyPlayer ? 'detailByPlayer' : 'playerAndAgentDetail'),
    withArrow: true,
  },
  {
    route: '/reports/player-reports/sport-bets',
    title: 'sportBets',
    withArrow: true,
    withoutTree: true,
  },
  {
    route: '/finance/my-debt-account',
    title: 'myDebtAccount',
    withArrow: true,
  },
  {
    route: '/finance/payments',
    title: 'payments',
    withArrow: true,
    withoutTree: true,
    withoutHeader: true,
  },
  // {
  //   route: '/finance/how-to-start',
  //   title: 'howToStart',
  //   exception: '/finance/how-to-start/flat',
  // },

  {
    route: '/user/create-player',
    title: 'createPlayer',
    userPage: true,
  },
  {
    route: '/user/create-agent',
    title: 'createAgent',
    userPage: true,
  },
  {
    route: '/user/deposit',
    title: 'deposit',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/withdrawal',
    title: 'withdrawal',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/enable',
    title: 'enableUser',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/disable',
    title: 'disableUser',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/change-password',
    title: 'changePassword',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/edit',
    title: 'userEdit',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/permissionsDetails',
    title: 'permissionsDetails',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/user/info',
    title: 'information',
    userPage: true,
    withArrow: true,
  },
  {
    route: '/bonus-promo/management',
    title: 'giftManagement',
    withArrow: true,
  },
  {
    route: '/bonus-promo/requests',
    title: 'requestForGift',
    withArrow: true,
  },
  {
    route: '/creative/cashback-creation',
    title: 'cashbackCreation',
    withArrow: true,
    withoutHeaderDesktop: true,
  },
  {
    route: '/bonus-promo/promotions',
    title: 'createPromotions',
    withArrow: true,
  },
  {
    route: '/bonus-promo/promotions/create',
    title: 'createPromotions',
    withArrow: true,
    // withoutHeaderDesktop: true,
  },
];
